<template>
  <div class="min-h-[800px]">

      <el-skeleton :rows="6" animated :loading="loading">
        <div ref="container" class="min-h-[800px] opacity-0 transition-opacity duration-1000 ease-in" :class="{'opacity-100': !loading}" v-html="dynamicComponent"></div>
      </el-skeleton>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      dynamicComponent: null
    };
  },
  props: {
    filePath: {
      type: String,
      required: true
    }
  },
  watch: {
    filePath(newPath) {
      this.loadHtmlContent(newPath);
    }
  },
  mounted() {
    this.loadHtmlContent(this.filePath);
  },
  methods: {
    async loadHtmlContent(path) {
      this.loading = true;
      try {
        // sleep 3s
        // await new Promise(resolve => setTimeout(resolve, 3000));

        const response = await axios.get(path);
        this.dynamicComponent = response.data;
        this.$nextTick(() => {
          this.attachEventHandlers();
        });
      } catch (error) {
        this.dynamicComponent = '<p>Error loading content.</p>';
        this.$nextTick(() => {
          this.attachEventHandlers();
        });
      } finally {
        this.loading = false;
      }
    },
    attachEventHandlers() {
      const button = this.$refs.container.querySelector('.btn');
      if (button) {
        button.addEventListener('click', this.clickBuy.bind(this));
      }
    },
    clickBuy() {
      this.$emit('clickBuy');
    }
  }
};
</script>

<style scoped>
</style>
